import CalendarRangeColor from './CalendarRangeColour.svg';
import CalendarRangeDark from './CalendarRangeDark.svg';
import CalendarRangeLight from './CalendarRangeLight.svg';
export const calendarRange = { color: CalendarRangeColor, dark: CalendarRangeDark, light: CalendarRangeLight };
//# sourceMappingURL=index.js.map